module.exports = __webpack_public_path__ + "img/ARR.79279b84.png";